// Component slice
import spinnerReducer from './components/spinnerSlice';
import alertReducer from './components/alertSlice';
import sidebarReducer from './components/sidebarSlice';
import modelReducer from './components/modelSlice';
import searchReducer from './components/searchSlice';

// Pages slice
import loginReducer from './pages/loginSlice';
import detailReducer from './pages/detailSlice';

// Common slice
import functionReducer from './functionSlice';

const reducer = {
    login: loginReducer,
    detail: detailReducer,
    alert: alertReducer,
    sidebar: sidebarReducer,
    spinner: spinnerReducer,
    model: modelReducer,
    search: searchReducer,
    function: functionReducer
}

export default reducer;